
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/guidelines",
      function () {
        return require("private-next-pages/es/guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/guidelines"])
      });
    }
  